import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Todo on todos {
    id
    title
    student_id
    assigned_to
    assigned_by
    due_date
    reminder
    priority
    note
    created_at
    updated_at
    __typename
  }
`;

export const UPSERT_TODO = gql`
  mutation upsertTodoTask($data: todos_insert_input!) {
    insert_todos_one(
      object: $data
      on_conflict: {
        constraint: todos_pkey
        update_columns: [
          title
          assigned_to
          assigned_by
          due_date
          reminder
          isDone
          isdeleted
          priority
          note
          student_id
          status
        ]
      }
    ) {
      ...Todo
      student {
        name
      }
    }
  }
  ${FRAGMENTS}
`;

export const UPDATE_TODO = gql`
  mutation updateTodo($id: Int!, $data: todos_set_input!) {
    row: update_todos_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Todo
    }
  }
  ${FRAGMENTS}
`;

export const GET_USERS = gql`
  query getUsers {
    users(
      where: {
        user_type: { _nin: ["parent"] }
        _or: [{ deleted: { _is_null: true } }, { deleted: { _neq: true } }]
      }
    ) {
      user_email
      user_phone
      user_first_name
      user_id
      user_last_name
      user_cognito_username
      user_status
      user_preferred_name
    }
  }
`;

export const GET_STUDENTS = gql`
  query getStudents {
    rows: v_students {
      user_id
      name
      user_first_name
      user_last_name
      lc_id
      hc_id
      fa_id
      admin_id
    }
  }
`;

export const GET_TODOS = gql`
  subscription getTodos($query: String, $status: String, $since: date) {
    todos(
      where: {
        isdeleted: { _neq: true }
        status: { _eq: $status }
        due_date: { _gt: $since }
        _or: [
          { user: { user_first_name: { _ilike: $query } } }
          { user: { user_last_name: { _ilike: $query } } }
          { priority: { _ilike: $query } }
          { title: { _ilike: $query }}
          { note: { _ilike: $query }}  
        ]
      },
      order_by: [{due_date: asc}, { priority: desc}]  
    ) {
      ...Todo
      user {
        user_first_name
        user_id
        user_last_name
        user_email
        timezone
      }
      student_id
      student {
        name
      }
      assignedBy {
        user_first_name
        user_id
        user_last_name
        timezone
      }
    }
  }
  ${FRAGMENTS}
`;

export const UPDATE_TASK_STATUS = gql`
  mutation updateTaskStatus($id: Int!) {
    update_todos(where: { id: { _eq: $id } }, _set: { isDone: true }) {
      affected_rows
    }
  }
`;

export const DELETE_TASK = gql`
  mutation deleteTask($id: Int!) {
    update_todos(where: { id: { _eq: $id } }, _set: { isdeleted: true }) {
      affected_rows
    }
  }
`;
export const GET_USER_TODOS = gql`
  subscription getTodos($userId: Int!, $status: [String]) {
    todos(
      where: {
        isdeleted: { _neq: true }
        assigned_to: { _eq: $userId }
        status: {
          _in: $status
        }
      }
      order_by: [{due_date: asc}, { priority: desc}]
    ) {
      ...Todo
      student {
        name
      }
      user {
        user_first_name
        user_email
        user_id
        user_last_name
        timezone
      }
      assignedBy {
        user_first_name
        user_email
        user_id
        user_last_name
        timezone
      }
    }
  }
  ${FRAGMENTS}
`;
